import { SEVERITY_COLOR_PALETTE } from '@/shared/config';
import type { Icon } from '@tabler/icons-react';
import IconCircleCheck from '@tabler/icons-react/dist/esm/icons/IconCircleCheck.mjs';
import IconCircleDashedMinus from '@tabler/icons-react/dist/esm/icons/IconCircleDashedMinus.mjs';
import IconCircleRectangle from '@tabler/icons-react/dist/esm/icons/IconCircleRectangle.mjs';
import IconCircleX from '@tabler/icons-react/dist/esm/icons/IconCircleX.mjs';
import IconExclamationCircle from '@tabler/icons-react/dist/esm/icons/IconExclamationCircle.mjs';
import IconLoader3 from '@tabler/icons-react/dist/esm/icons/IconLoader3.mjs';

export const HI_STATUS = {
  NO_DATA: 1,
  OK: 2,
  WARNING: 3,
  ERROR: 4,
  CRITICAL_ERROR: 5,
  SERVICE: 6,
} as const;

export type HIStatus = (typeof HI_STATUS)[keyof typeof HI_STATUS];

type HIStatusMap<T> = Record<HIStatus, T>;

export const HI_STATUS_COLOR = SEVERITY_COLOR_PALETTE as HIStatusMap<string>;

export const HI_STATUS_LABEL: HIStatusMap<string> = {
  [HI_STATUS.NO_DATA]: 'monitoring:hiStatusValues.noData',
  [HI_STATUS.OK]: 'monitoring:hiStatusValues.ok',
  [HI_STATUS.WARNING]: 'monitoring:hiStatusValues.warning',
  [HI_STATUS.ERROR]: 'monitoring:hiStatusValues.error',
  [HI_STATUS.CRITICAL_ERROR]: 'monitoring:hiStatusValues.criticalError',
  [HI_STATUS.SERVICE]: 'monitoring:hiStatusValues.service',
};

export const HI_STATUS_ICON: HIStatusMap<Icon> = {
  [HI_STATUS.NO_DATA]: IconCircleDashedMinus,
  [HI_STATUS.OK]: IconCircleCheck,
  [HI_STATUS.WARNING]: IconExclamationCircle,
  [HI_STATUS.ERROR]: IconCircleX,
  [HI_STATUS.CRITICAL_ERROR]: IconCircleRectangle,
  [HI_STATUS.SERVICE]: IconLoader3,
};

export const METRICS_TYPE = {
  RAW: 'raw',
  CALCULATE: 'calculate',
  EVENT: 'event',
} as const;

export type MetricsType = (typeof METRICS_TYPE)[keyof typeof METRICS_TYPE];

const VALUES = {
  BEST: 'best',
  WORST: 'worst',
  AVERAGE: 'average',
  PERCENTILE: 'percentile',
  FREQUENCY: 'frequency',
} as const;

const indexed = Object.values(VALUES).reduce(
  (acc, value, index) => {
    acc[index + 1] = value;
    return acc;
  },
  {} as Record<number, (typeof VALUES)[keyof typeof VALUES]>,
);

export const METRICS_EXPRESSION = {
  ...VALUES,
  ...indexed,
} as const;

export type MetricsExpression = (typeof VALUES)[keyof typeof VALUES];

export const METRICS_EXPRESSION_OPTIONS = Object.values(VALUES).map(
  (value, index) => ({
    value: String(index + 1),
    expression: value,
  }),
);

export const SEVERITY_DEFAULT_VALUE = 'severity';